import { Trans } from "@coworker/locales";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";

interface MessageModalProps {
  message: string;
  closeModal: () => void;
}

export const LocalCombinationDeletedMessageModal = ({
  message,
  closeModal,
}: MessageModalProps) => {
  return (
    <FixaModal visible={!!message} handleCloseBtn={() => closeModal()}>
      <FixaSheets
        header={<FixaModalHeader ariaCloseTxt={"Close modal"} />}
        footer={null}
      >
        <FixaModalBody>
          <div>
            <p style={{ marginBottom: "14px" }}>
              {<Trans>localCombinationInformationMessageOneString</Trans>}
            </p>
            <p>{<Trans>localCombinationInformationMessageTwoString</Trans>}</p>
          </div>
        </FixaModalBody>
      </FixaSheets>
    </FixaModal>
  );
};
